export default "__VITE_ASSET__pp9o2kZy__"